import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { useQueryParams } from "../../../lib/useQueryParams";
import { addQueryLocalStorage, removeQueryLocalStorage } from '../../../lib/utils';

const Birthday = (props) => {

  const [upcomingBirthday, setUpcomingBirthday] = useState(false);

  const toggleUpcomingBirthday = () => {
    if(upcomingBirthday){
      setUpcomingBirthday(false);
      removeQueryLocalStorage("upcoming_birthday");
    }else{
      setUpcomingBirthday(true);
      addQueryLocalStorage("upcoming_birthday", true); 
    }
  }
  const location = useLocation();
  const {getAllQueryParams} = useQueryParams();

  useEffect(()=>{
    const q = getAllQueryParams();
    if(q?.upcoming_birthday) setUpcomingBirthday(true);
    else setUpcomingBirthday(false);
  },[location.search]);

  useEffect(()=>{
    if(props.isReset){
      setUpcomingBirthday(false);
      if(props.handleResetState) props.handleResetState();
    }
  },[props.isReset]);

  useEffect(() => {
    if (props.isReset) {
      setUpcomingBirthday(false);
      if (props.handleResetState) {
        props.handleResetState();
      }
    }
  }, [props.isReset]);

  return(
    <div onClick={()=>toggleUpcomingBirthday()} className="d-flex">
      <input className='flex-item m-r-8' type="checkbox" style={{width:"18px", height:"18px"}} checked={upcomingBirthday} />
      <p className="flex-item fs-16 font-weight-700" style={{lineHeight:"16px"}}>Upcoming Birthday's</p>
    </div>
  ) 
}

export default Birthday;